// extracted by mini-css-extract-plugin
export default {"Actions":"CabinetProduct_Actions__gyrs3","Image":"CabinetProduct_Image__01Pkv"};